import React from "react";
import { Builder } from "@builder.io/react";
import { FeatureModuleDetailType } from "@components/RedesignComponents/types/FeatureModuleDetail";
import { segmentTrack } from "@utils/segment/segment-track";
import { usePathname } from "next/navigation";
import FeatureModuleDetail from "@components/RedesignComponents/FeatureModuleDetail/FeatureModuleDetail";
import { navigate } from "gatsby";

const FeatureModuleDetailWrapper: React.FC<FeatureModuleDetailType> = data => {
  const pathname = usePathname();

  const triggerAnalytics = (link: string, text: string) => {
    segmentTrack("Link Clicked", {
      target: link,
      text,
      url: pathname,
      action: "Clicked",
      initiator: "User",
      object: "Link",
      source_application: "Marketing",
    });
  };

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault();

    triggerAnalytics(e.currentTarget.pathname, e.currentTarget.text);

    navigate(e.currentTarget.href);
  };

  return <FeatureModuleDetail {...data} onClick={onClick} />;
};

export default FeatureModuleDetailWrapper;

export const RegisterFeatureDetail = () => {
  Builder.registerComponent(FeatureModuleDetailWrapper, {
    name: "feature-detail",
    inputs: [
      {
        name: "feature",
        type: "list",
        subFields: [
          {
            name: "headline",
            type: "string",
          },
          {
            name: "Subcopy",
            type: "richText",
          },
          {
            name: "ctaCopy",
            type: "string",
          },
          {
            name: "ctaLink",
            type: "reference",
            model: "page",
          },
          {
            name: "ctaUrl",
            type: "string",
          },
          {
            name: "backgroundColor",
            type: "color",
          },
          {
            name: "desktopTabletAsset",
            type: "object",
            subFields: [
              {
                name: "image",
                type: "file",
                helperText: "If Lottie is added, serves as fallback image.",
              },
              {
                name: "imageAltText",
                type: "longText",
              },
              {
                name: "lottie",
                type: "file",
                helperText: "Optional. If not uploaded, image is shown.",
              },
              {
                name: "lottieLoop",
                type: "boolean",
                defaultValue: true,
              },
            ],
          },
          {
            name: "mobileAsset",
            type: "object",
            subFields: [
              {
                name: "image",
                type: "file",
                helperText: "If Lottie is added, serves as fallback image.",
              },
              {
                name: "imageAltText",
                type: "longText",
              },
              {
                name: "lottie",
                type: "file",
                helperText: "Optional. If not uploaded, image is shown.",
              },
              {
                name: "lottieLoop",
                type: "boolean",
                defaultValue: true,
              },
            ],
          },
        ],
      },
    ],
  });
};
